import React, {useEffect, useState} from "react";
import './Ilogin.scss';
import {
  IonButton,
  IonCol, IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonPage,
  IonRow,
  IonText,
} from "@ionic/react";
import ihLogoWhite from "../../media/ih-logo-white.png";
import {Drawer, useMediaQuery} from "@material-ui/core";
import ihLogo from "../../media/ih-logo-on-dark.png";
import moved from "../../media/moved.png";
import {menuOutline} from "ionicons/icons";

export const Ilogin: React.FC = () => {
  const [selected, setSelected] = useState('Home')
  const isMobile = useMediaQuery('(max-width: 834px)')
  useEffect(() => {
    const temp = localStorage.getItem('selected')
    setSelected(temp ? temp : '')
  }, [])
  React.useEffect(() => {
    localStorage.setItem('selected', selected)
  }, [selected])
  const [isMenuOpened, setIsMenuOpened] = useState(false)
  return (
      <IonPage className="page">
        <IonHeader className="page-header">
          <IonGrid className="header-grid">
            <IonRow>
              <IonCol size="1" sizeXs="5" sizeMd="2">
                <a href="https://intermountainhealthcare.org/">
                  <img src={ihLogo} className="ihLogo" />
                </a>
              </IonCol>
              {isMobile ? (
                  <IonCol size="12" sizeXs="7" sizeMd="9">
                    <IonButton
                        class="ion-float-end"
                        fill="clear"
                        onClick={() => setIsMenuOpened(true)}
                    >
                      <IonIcon
                          icon={menuOutline}
                          style={{ color: 'white', fontSize: '30px' }}
                      />
                    </IonButton>
                  </IonCol>
              ) : (
                  <>
                    <IonCol
                        size="6"
                        style={{ marginLeft: '30px', marginTop: '20px' }}
                    >
                    </IonCol>
                    <IonCol size="1">

                    </IonCol>
                  </>
              )}
            </IonRow>
          </IonGrid>
        </IonHeader>
        <IonContent>
        <section>
          <div className="phy-app-container">
            <main>
              <div className="phy-app-main-grid">
                <div className="left-column">
                  <img src={moved} alt="Patient and doctor interaction" width="640" height="427"/>
                  <p>
                    You've reached this page because you are using a link that no longer works. Please click on the appropriate button to the right and update your bookmarks to the new page.
                  </p>
                  <h2>Please bookmark this page: <a href="https://my.intermountain.net" target="_blank">https://my.intermountain.net</a></h2>
                </div>

                <section className="content2">
                  <h2>Intermountain Caregivers, UofU, and Intermountain Health Affiliated Providers:</h2>
                  <div className="phy-app-links">
                    <p><a href="https://my.intermountain.net" target="_blank">Go to MyIntermountain</a></p>
                    <p><a href="https://intermountainhealth.service-now.com/servicehub?id=kb_article&sysparm_article=KB0032019" target="_blank">Go to UofU Help Article</a></p>
                  </div>
                  <h2>Select Health Affiliated Providers and Caregivers:</h2>
                  <div className="phy-app-links">
                    <p><a href="https://selecthealth.org/providers/" target="_blank">Go to Select Health Portal</a></p>
                  </div>
                  <h2>Surgery Schedules:</h2>
                  <div className="phy-app-links">
                    <p><a href="https://intermountainhealth.sharepoint.com/sites/Clinical-Resources/SitePages/Surgery-Schedule---Canyons-Desert-Region.aspx" target="_blank">View Schedules</a></p>
                    <p><a href="https://apps.apple.com/us/app/intermountain-providers/id1516753238" target="_blank">Download iPhone Provider App</a></p>
                  </div>
                  <h2>Intermountain Office Manager | Affiliated DSAs:</h2>
                  <div className="phy-app-links">
                  <p><a href="https://intermountainhealthcare.org/for-professionals/affiliated-support" target="_blank">Go to Affiliate DSA Portal</a></p>
                  </div>
                  <br/>
                  <p>If you experience issues, please file a ticket in <a href="https://intermountainhealth.service-now.com/servicehub/" target="_blank">ServiceHub</a> or contact our Service Desk</p>
                </section>
              </div>
            </main>
            <div className="phy-app-footer"></div>
          </div>
        </section>
        </IonContent>
        <IonFooter className="footer">
          <IonGrid>
            <IonCol size="2" sizeXs="5" sizeMd="2">
              <img src={ihLogoWhite} className="ihLogoWhite" />
            </IonCol>
            <IonCol
                size="10"
                sizeXs="9"
                sizeMd="9"
                style={{ top: '-5px', marginLeft: '-10%' }}
            >
              <IonText>
                Copyright &#169;{new Date().getFullYear()}, Intermountain Health, All Rights
                Reserved
              </IonText>
            </IonCol>
            <IonCol size="7" sizeXs="9" sizeMd="9"></IonCol>
            <IonCol size="7" sizeXs="9" sizeMd="9"></IonCol>
          </IonGrid>
        </IonFooter>
        <Drawer
            anchor="right"
            open={isMenuOpened}
            onClose={() => setIsMenuOpened(false)}
            className="dashboard-options"
            data-testid={`dashboard-options`}
            style={{ width: 'fit-content' }}
        >
          <IonHeader
              className="ion-margin-start ion-margin-top ion-margin-bottom"
              style={{
                fontWeight: '600',
                borderBottom: '2px solid #ccc6c6',
                fontSize: '30px',
              }}
          >
            MENU
          </IonHeader>
        </Drawer>
      </IonPage>

  )
}
